import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ACCOUNT, BOOKINGCALENDAR } from '../../../reduxs'
import { StyleTopbar } from './style'
import Select, { components } from 'react-select'
import { ROUTE, getMonthNameFull, TOP_BAR } from '../../../helpers'
import { Topbar } from '../../../components'
import { COLOR } from '../../../themes'

class TopbarCalendar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      language: props.accountReducer.language,
      date: props.date,
      month: props.month - 1,
      year: props.year,
      view: { label: props.match.params.view, value: props.match.params.view },
    }
  }

  onChangeView = (e) => {
    const { date, month, year } = this.props
    this.setState({
      view: { label: e.value, value: e.value }
    }, () => {
      let path = `${ROUTE.CALENDAR.LINK}/${e.value}/${year}/${month}/${date}`
      this.props.history.push(path)
    })
  }

  increaseDay = () => {
    const {
      month,
      year,
      date,
      history,
      match
    } = this.props

    let newDate = new Date(year, month - 1, date + 1)
    let view = match.params.view
    let path = `${ROUTE.CALENDAR.LINK}/${view}/${newDate.getFullYear()}/${newDate.getMonth() + 1}/${newDate.getDate()}`
    history.push(path)

    this.getAllListEventSideBar(newDate.getMonth(), year)
  }

  increaseWeek = () => {
    const {
      month,
      year,
      date,
      history,
      match
    } = this.props

    let newDate = new Date(year, month - 1, date + 7)
    let view = match.params.view
    let path = `${ROUTE.CALENDAR.LINK}/${view}/${newDate.getFullYear()}/${newDate.getMonth() + 1}/${newDate.getDate()}`
    history.push(path)
  }

  increaseMonth = () => {
    const {
      month,
      year,
      history,
      match
    } = this.props

    let newDate = new Date(year, month, 1)
    let view = match.params.view
    let path = `${ROUTE.CALENDAR.LINK}/${view}/${newDate.getFullYear()}/${newDate.getMonth() + 1}/${newDate.getDate()}`
    history.push(path)

    this.getAllListEventSideBar(month, year)
  }

  increaseYear = () => {
    const {
      month,
      year,
      history,
      match
    } = this.props

    let newDate = new Date(year + 1, month - 1, 1)
    let view = match.params.view
    let path = `${ROUTE.CALENDAR.LINK}/${view}/${newDate.getFullYear()}/${newDate.getMonth() + 1}/${newDate.getDate()}`
    history.push(path)

    this.getAllListEventSideBar(month - 1, year + 1)
  }

  decreaseDay = () => {
    const {
      month,
      year,
      date,
      history,
      match
    } = this.props

    let newDate = new Date(year, month - 1, date - 1)
    let view = match.params.view
    let path = `${ROUTE.CALENDAR.LINK}/${view}/${newDate.getFullYear()}/${newDate.getMonth() + 1}/${newDate.getDate()}`
    history.push(path)

    this.getAllListEventSideBar(newDate.getMonth(), year)
  }

  decreaseWeek = () => {
    const {
      month,
      year,
      date,
      history,
      match
    } = this.props

    let newDate = new Date(year, month - 1, date - 7)
    let view = match.params.view
    let path = `${ROUTE.CALENDAR.LINK}/${view}/${newDate.getFullYear()}/${newDate.getMonth() + 1}/${newDate.getDate()}`
    history.push(path)
  }

  decreaseMonth = () => {
    const {
      month,
      year,
      history,
      match
    } = this.props

    let newDate = new Date(year, month - 2, 1)
    let view = match.params.view
    let path = `${ROUTE.CALENDAR.LINK}/${view}/${newDate.getFullYear()}/${newDate.getMonth() + 1}/${newDate.getDate()}`
    history.push(path)

    this.getAllListEventSideBar(month - 2, year)
  }

  decreaseYear = () => {
    const {
      month,
      year,
      history,
      match
    } = this.props

    let newDate = new Date(year - 1, month - 1, 1)
    let view = match.params.view
    let path = `${ROUTE.CALENDAR.LINK}/${view}/${newDate.getFullYear()}/${newDate.getMonth() + 1}/${newDate.getDate()}`
    history.push(path)

    this.getAllListEventSideBar(month - 1, year - 1)
  }

  pathChange = () => {
    const { history, match } = this.props

    let newDate = new Date()
    let view = match.params.view
    let path = `${ROUTE.CALENDAR.LINK}/${view}/${newDate.getFullYear()}/${newDate.getMonth() + 1}/${newDate.getDate()}`
    history.push(path)

    this.getAllListEventSideBarToday(newDate.getMonth() + 1, newDate.getFullYear(), view)
  }

  getAllListEventSideBarToday = async (month, year, view) => {
    const {
      bookingcalendarAction,
      accountReducer,
      setSelectedToday,
    } = this.props
    const { userId, username } = accountReducer.user

    await setSelectedToday(true)

    bookingcalendarAction.getAllListEventSideBar({
      userId,
      username,
      month,
      year,
      status: '[0,1,2]'
    })
  }

  getAllListEventSideBar = (month, year) => {
    const { bookingcalendarAction, accountReducer } = this.props
    const { userId, username } = accountReducer.user

    bookingcalendarAction.clearAllListEventSideBar()
    bookingcalendarAction.getAllListEventSideBar({
      userId,
      username,
      month: month + 1,
      year,
      status: '[0,1,2]'
    })
  }

  renderDropDownValue = ({ children, ...props }) => {
    return (
      <components.Control
        {...props}
        className="icon-calendar-dropdown-container"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="19.936"
          viewBox="0 0 20 19.936"
          className="icon-calendar-dropdown"
        >
          <g transform="translate(-0.41 0)">
            <path d="M20.329,4.9h-2.3V3.485a.89.89,0,0,0-.885-.885H16.072a.89.89,0,0,0-.885.885V4.876H9.834V3.485A.89.89,0,0,0,8.949,2.6H7.874a.89.89,0,0,0-.885.885V4.876h-2.3A2.19,2.19,0,0,0,2.5,7.068V20.345a2.19,2.19,0,0,0,2.192,2.192H20.308A2.19,2.19,0,0,0,22.5,20.345V7.068A2.168,2.168,0,0,0,20.329,4.9Zm.253,14.773a.944.944,0,0,1-.948.948H5.387a.944.944,0,0,1-.948-.948V10.018H20.561V19.67Z" transform="translate(-2.09 -2.6)" />
            <text className="a" transform="translate(5.91 15.337)">
              <tspan x="0" y="0">31</tspan>
            </text>
          </g>
        </svg>
        {children}
      </components.Control>
    )
  }

  renderDropDownSingleValue = ({ children, ...props }) => {
    return (
      <components.SingleValue
        {...props}
        className="icon-calendar-dropdown-singlevalue"
      >
        {children}
      </components.SingleValue>
    )
  }

  onClickLeftArrow = (currentView) => {
    switch (currentView.value) {
      case 'day':
        return this.decreaseDay()
      case 'week':
        return this.decreaseWeek()
      case 'month':
        return this.decreaseMonth()
      case 'year':
        return this.decreaseYear()

      default:
        return null
    }
  }

  onClickRightArrow = (currentView) => {
    switch (currentView.value) {
      case 'day':
        return this.increaseDay()
      case 'week':
        return this.increaseWeek()
      case 'month':
        return this.increaseMonth()
      case 'year':
        return this.increaseYear()

      default:
        return null
    }
  }

  render () {
    const { language } = this.state
    const { date, year, month, view, settingReducer } = this.props
    const { colorTheme } = settingReducer.settingTheme

    let currentView
    switch (view.toLowerCase()) {
      case 'year':
        currentView = TOP_BAR.TYPEVIEW[language][0]
        break
      case 'day':
        currentView = TOP_BAR.TYPEVIEW[language][2]
        break
      default:
        currentView = TOP_BAR.TYPEVIEW[language][1]
        break
    }
    return (
      <StyleTopbar colorTheme={colorTheme}>
        <Topbar
          addonComponent={() => (
            <React.Fragment>

              {/* ========== [Arrow left and right button] ========== */}
              {view !== 'day' && (
                <React.Fragment>
                  <button className='arrow__button left' onClick={() => this.onClickLeftArrow(currentView)}>
                    <h1>{String.fromCharCode('8249')}</h1>
                  </button>
                  <button className='arrow__button right' onClick={() => this.onClickRightArrow(currentView)}>
                    <h1>{String.fromCharCode('8250')}</h1>
                  </button>
                </React.Fragment>
              )}

              {/* ========== [Month and Year] ========== */}
              <div className='text-month'>
                {getMonthNameFull(new Date(year, month - 1, date), language)}
              </div>
              <div className='text-year'>
                {year}
              </div>

              {/* ========== [Box today] ========== */}
              <div className='box-today' onClick={() => { this.pathChange() }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="19.936"
                  viewBox="0 0 20 19.936"
                >
                  <g transform="translate(0 0)">
                    <g transform="translate(0 0)">
                      <path
                        d="M33.947,54.354a.884.884,0,0,0,.652.261.964.964,0,0,0,.652-.261l3.11-3.11a.922.922,0,0,0-1.3-1.3L34.6,52.4l-1.155-1.155a.922.922,0,0,0-1.3,1.3Z"
                        transform="translate(-25.239 -39.304)"
                      />
                      <path
                        d="M20.329,4.9h-2.3V3.485a.89.89,0,0,0-.885-.885H16.072a.89.89,0,0,0-.885.885V4.876H9.834V3.485A.89.89,0,0,0,8.949,2.6H7.874a.89.89,0,0,0-.885.885V4.876h-2.3A2.19,2.19,0,0,0,2.5,7.068V20.345a2.19,2.19,0,0,0,2.192,2.192H20.308A2.19,2.19,0,0,0,22.5,20.345V7.068A2.168,2.168,0,0,0,20.329,4.9Zm.253,14.773a.944.944,0,0,1-.948.948H5.387a.944.944,0,0,1-.948-.948V10.018H20.561V19.67Z"
                        transform="translate(-2.5 -2.6)"
                      />
                    </g>
                  </g>
                </svg>
                {TOP_BAR.TODAY[language]}
              </div>

              {/* ========== [Box view selector] ========== */}
              <div className='box-view-selector'>
                <Select
                  components={{
                    Control: this.renderDropDownValue,
                    SingleValue: this.renderDropDownSingleValue
                  }}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? COLOR.WHITE : COLOR.WHITE,
                      boxShadow: state.isFocused ? null : null,
                      ':hover': {
                        borderColor: COLOR.GRAY_19,
                      },
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? colorTheme : COLOR.WHITE,
                      ':hover': {
                        backgroundColor: state.isSelected ? colorTheme : COLOR.PEARL,
                      },
                      cursor: 'pointer',
                      color: COLOR.BLACK_1,
                      textAlign: 'center'
                    })
                  }}
                  isSearchable={false}
                  options={TOP_BAR.TYPEVIEW[language]}
                  value={currentView}
                  onChange={(e) => { this.onChangeView(e) }}
                />
              </div>
            </React.Fragment>
          )}
        />
      </StyleTopbar>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    accountAction: bindActionCreators(ACCOUNT.action, dispatch),
    bookingcalendarAction: bindActionCreators(BOOKINGCALENDAR.action, dispatch),
  }
}

const mapStateToProps = ({
  accountReducer,
  loaderReducer,
  bookingcarlendarReducer, // from phase 1
  settingReducer,
}) => {
  return {
    accountReducer,
    loaderReducer,
    bookingcarlendarReducer, // from phase 1
    settingReducer,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopbarCalendar)
